import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Globals } from '../objects/Globals';
import { Subject } from 'rxjs';
import { EnvService } from '../env.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../objects/Globals";
import * as i3 from "../env.service";
var ViewService = /** @class */ (function () {
    function ViewService(http, globals, env) {
        this.http = http;
        this.globals = globals;
        this.env = env;
        this.refreshView = new Subject();
        this.refreshViewChanged$ = this.refreshView.asObservable();
        this.loginUrl = this.env.servicePath;
    }
    ViewService.prototype.setRefreshView = function (view) {
        if (view) {
            this.refreshView.next(view);
        }
    };
    ViewService.prototype.createViewList = function (type) {
        var path = this.loginUrl + "CreateViewListCard/" + type;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    ViewService.prototype.getViewList = function (id) {
        var path = this.loginUrl + "GetViewListCard/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    ViewService.prototype.getSystemViewList = function (id) {
        var path = this.loginUrl + "GetSystemViewListCard/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    ViewService.prototype.getUserViewList = function (id) {
        var path = this.loginUrl + "GetUserViewListCard/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    ViewService.prototype.getViewChildrenList = function (id, viewId) {
        var path = this.loginUrl + "GetViewChildrenList/" + id + "/" + viewId;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    ViewService.prototype.getViewDetail = function (id, viewId) {
        var path = this.loginUrl + "GetViewDetail/" + id + "/" + viewId;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    ViewService.prototype.createNewView = function (summaryId, viewName, parentId) {
        var path = this.loginUrl + "CreateNewView/" + summaryId + "/" + viewName + "/" + parentId;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    ViewService.prototype.getDocumentOutlineCard = function (id) {
        var path = this.loginUrl + "GetDocumentOutlineCard/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    ViewService.prototype.selectOutlineItem = function (id, itemId) {
        var path = this.loginUrl + "SelectOutlineItem/" + id + "/" + itemId;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    ViewService.prototype.getDocumentOutlineChildItems = function (id, selectedId) {
        var path = this.loginUrl + "GetDocumentOutlineChildItems/" + id + "/" + selectedId;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    ViewService.ngInjectableDef = i0.defineInjectable({ factory: function ViewService_Factory() { return new ViewService(i0.inject(i1.HttpClient), i0.inject(i2.Globals), i0.inject(i3.EnvService)); }, token: ViewService, providedIn: "root" });
    return ViewService;
}());
export { ViewService };
